import { Link } from "react-router-dom";
import { Minus, Plus, Trash2 } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useCart } from "@/context/CartContext";
import { eur, img } from "@/lib/api";

export const CartLine = ({ line, compact = false }) => {
  const { setQty, remove } = useCart();
  return (
    <div className="flex gap-3 py-4" data-testid={`cart-line-${line.key}`}>
      <Link to={`/prodotto/${line.slug}`} className="h-20 w-20 shrink-0 overflow-hidden rounded-xl border border-slate-200 bg-white">
        {line.image && <img src={img(line.image)} alt="" className="h-full w-full object-contain p-1.5" />}
      </Link>
      <div className="min-w-0 flex-1">
        <p className="line-clamp-2 text-sm font-semibold text-slate-900">{line.name}</p>
        {line.options.map((o) => (
          <p key={o.name + o.value} className="text-xs text-slate-500">{o.name}: {o.value}{o.markup ? ` (+${eur(o.markup)})` : ""}</p>
        ))}
        <div className="mt-2 flex items-center justify-between">
          <div className="flex items-center rounded-full border border-slate-200 text-slate-900">
            <button className="p-1.5 text-slate-500 hover:text-slate-900" onClick={() => setQty(line.key, line.qty - 1)} aria-label="Diminuisci" data-testid="cart-line-decrease"><Minus className="h-3.5 w-3.5" /></button>
            <span className="w-7 text-center font-mono text-xs" data-testid="cart-line-qty">{line.qty}</span>
            <button className="p-1.5 text-slate-500 hover:text-slate-900" onClick={() => setQty(line.key, line.qty + 1)} aria-label="Aumenta" data-testid="cart-line-increase"><Plus className="h-3.5 w-3.5" /></button>
          </div>
          <span className="font-display text-sm font-bold text-slate-900">{eur(line.unit_price * line.qty)}</span>
        </div>
      </div>
      {!compact && (
        <button onClick={() => remove(line.key)} className="self-start p-1 text-slate-400 hover:text-red-500" aria-label="Rimuovi" data-testid="cart-line-remove"><Trash2 className="h-4 w-4" /></button>
      )}
    </div>
  );
};

export const CartDrawer = () => {
  const { items, open, setOpen, subtotal } = useCart();
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="flex w-full flex-col border-slate-200 bg-white text-slate-900 sm:max-w-md" data-testid="cart-drawer">
        <SheetHeader><SheetTitle className="font-display text-xl font-bold text-slate-900">Il tuo carrello</SheetTitle></SheetHeader>
        <div className="-mx-2 flex-1 divide-y divide-slate-100 overflow-y-auto px-2">
          {items.length ? items.map((l) => <CartLine key={l.key} line={l} />) : <p className="py-16 text-center text-sm text-slate-500" data-testid="cart-empty">Il carrello è vuoto.</p>}
        </div>
        {items.length > 0 && (
          <div className="border-t border-slate-200 pt-4">
            <div className="flex justify-between text-sm"><span className="text-slate-500">Subtotale</span><span className="font-display text-lg font-bold" data-testid="cart-drawer-subtotal">{eur(subtotal)}</span></div>
            <Link to="/carrello" onClick={() => setOpen(false)} data-testid="cart-drawer-go-cart"
              className="mt-4 flex h-12 items-center justify-center rounded-full bg-[#0066FF] font-semibold text-white transition-colors hover:bg-[#1a75ff]">
              Vai al carrello
            </Link>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
};
